import store                 from '@/store';
import { useField, useForm } from 'vee-validate';
import { ref }               from "vue";
import * as yup              from 'yup';
import UserDataService       from './services/UserDataService';

export default {

    name: 'Usuario',

    data: () => ({
        check_senha: '',
        isFormDPValid: false,
        loadingUserPwd: false,
        old_senha: '',
        passwordRules: [
            v => !!v || 'O campo é obrigatório.',
            v => (v && /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,}$/.test(v)) || 
            'A senha precisa conter 6 ou mais caracteres com pelo menos um de cada: letra maiúscula, letra minúscula, número e caractere especial.'
        ],
        requiredField: [v => !!v || 'O campo é obrigatório.'],
        senha: '',
        show1: false,
        show2: false,
        show3: false,
    }),

    setup() {
        const alert           = ref(false);
        const alertText       = ref('');
        const alertType       = ref(null);
        const items       = ref([
            { value: 'm',  title: 'Masculino' },
            { value: 'f',  title: 'Feminino' },
            { value: 'ni', title: 'Não desejo informar' },
        ]);
        const loadingUserData = ref(false);
        //const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
        const phoneRegExp = /^\(\d{2}\) \d{4,5}-\d{4}$/;
        const sbColor     = ref('');
        const sbMessage   = ref('');
        const snackbar    = ref(false);

        const validationSchema = yup.object().shape({
            nome: yup.string().min(2,'O nome precisa ter pelo menos 2 caracteres.'),
            sexo: yup.mixed().oneOf(['m','f','ni']).defined('Selecione uma opção.'),
            fone: yup.string().matches(phoneRegExp, 'Número de telefone inválido.'),
        });

        const { handleSubmit, handleReset } = useForm({
            validationSchema,
        });
        
        const cpf   = useField('cpf', validationSchema);
        const email = useField('email', validationSchema);
        const nome  = useField('nome', validationSchema);
        const sexo  = useField('sexo', validationSchema);
        const fone  = useField('fone', validationSchema);
    
        const onSubmit = handleSubmit(async (values) => {
            loadingUserData.value = true;
            UserDataService.update({id: store.state.userId, nome: nome.value.value, genero: sexo.value.value, telefone: fone.value.value.replace(/\D/g, '')}).then(response => {
                alertType.value = 'success';
                alertText.value = 'Dados alterados com sucesso!';
                sbColor.value   = alertType.value;
                sbMessage.value = alertText.value;
            }).catch(error => {
                alertType.value = 'error';
                alertText.value = error.message;
                sbColor.value   = alertType.value;
                sbMessage.value = alertText.value;
            })
            alert.value           = true;
            snackbar.value        = true;
            loadingUserData.value = false;
        });

        return {alert, alertType, alertText, sbColor, sbMessage, snackbar, loadingUserData, cpf, email, nome, items, sexo, fone, onSubmit, handleReset};
    },

    mounted() {
        if(this.$route.params.uPage === 'DadosPessoais') {
            this.getUserData();
        }
    },

    computed: {
        currentParamsPage() {
            return this.$route.params.uPage;
        },
        passwordConfirmationRule() {
            return () => (this.senha === this.check_senha) || 'As senhas precisam ser idênticas.'
        },
    },

    watch: {
        alert(new_val){
            if(new_val){
              setTimeout(()=>{this.alert=false}, 5000)
            }
        },  
        currentParamsPage(newVal) {
            this.alert = false;
            if (newVal === 'DadosPessoais') {
                this.getUserData();
            }
        }
    },

    methods: {
        async getUserData() {
            await UserDataService.read(store.state.userId).then(response => {
                this.cpf.value.value   = response.data.cpf;
                this.email.value.value = response.data.email;
                this.nome.value.value  = response.data.nome;
                this.sexo.value.value  = response.data.genero;
                this.fone.value.value  = response.data.telefone;
            }).catch(error => {
                this.alertType = 'error';
                this.alertText = error.message;
                this.alert     = true;
                this.sbColor   = this.alertType;
                this.sbMessage = this.alertText;
                this.snackbar  = true;
            })
        },

        //###################### Melhorar ######################
        async onSubmitChangePwd() {
            this.loadingUserPwd = true;
            const { valid } = await this.$refs.formChangePwd.validate();
            if (valid) {
                UserDataService.changePwd({old_password: this.old_senha, new_password: this.senha}).then(response => {
                    this.alertType = 'success';
                    this.alertText = 'Senha alterada com sucesso!';
                    this.sbColor   = this.alertType;
                    this.sbMessage = this.alertText;
                }).catch(error => {
                    this.alertType = 'error';
                    this.alertText = error.response.data.error;
                    this.sbColor   = this.alertType;
                    this.sbMessage = this.alertText;
                })
                this.$refs.formChangePwd.reset();
                this.alert    = true;
                this.snackbar = true;
            }
            this.loadingUserPwd = false;
        },
    }
};
